import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import { PiniaVuePlugin } from "pinia";
import VueCompositionAPI from "@vue/composition-api";
import pinia from "@/stores";
import i18next from "i18next";
import I18NextVue from "i18next-vue";
import langs from "@/langs";
import VueCroppie from "vue-croppie";
import "croppie/croppie.css";
import bToast from "b-toast";
import "b-toast/dist/bToast.css";
Vue.use(VueCroppie);
Vue.use(bToast);
i18next.init({
  lng: "br",
  resources: langs,
});

Vue.use(I18NextVue, { i18next });

Vue.use(VueCompositionAPI);

Vue.use(PiniaVuePlugin);
Vue.config.productionTip = false;

const app = new Vue({
  router,
  vuetify,
  pinia,
  render: (h) => h(App),
});
export default app;
app.$mount("#app");
